export default "__VITE_ASSET__BqqTtZHR__"